const formatDate = function (date) {
  if (typeof date === "object") {
    let month = date.getMonth()+1;
    if (month < 10) {
      month = "0" + month;
    }
    let day = date.getDate();
    if (day < 10) {
      day = "0" + day;
    }
    return day + "/" + month + "/" + date.getFullYear();
  } else {
    let dateParts = date.split("/");
    return dateParts[1] + "/" + dateParts[0] + "/" + dateParts[2];
  }
}

const formatDateByScope = function (date, scopeDefault, scope) {
  if (typeof date === "object") {
    let month = date.getMonth()+1;
    if (month < 10) {
      month = "0" + month;
    }
    let day = date.getDate();
    if (day < 10) {
      day = "0" + day;
    }
    if((scope && scope.format_date === 'DD/MM/YYYY') ||
      (!scope && scopeDefault === 'DD/MM/YYYY')) {
      return day + "/" + month + "/" + date.getFullYear();
    } else {
      return month + "/" + day + "/" + date.getFullYear();
    }

  } else {
    let dateParts = date.split("/");
    if((scope && scope.format_date === 'DD/MM/YYYY') ||
      (!scope && scopeDefault === 'DD/MM/YYYY')) {
      return dateParts[0] + "/" + dateParts[1] + "/" + dateParts[2];
    } else {
      return dateParts[1] + "/" + dateParts[0] + "/" + dateParts[2];
    }
  }
}

// const DDMMYYYY_toDayObject = function(date) {
//   const dateMomentObject = moment(dateString, "DD/MM/YYYY"); // 1st argument - string, 2nd argument - format
//   var dateObject = dateMomentObject.toDate();
// }

export {
  formatDate,
  formatDateByScope
}
